import { FC } from 'react'

import { EmbroideryDisclosure } from '../../../../../../../brunswick/components/EmbroideryDisclosure/index'
import { EmbroideryCtaSection } from '../../../../../../../components/embroidery/EmbroideryCtaSection'
import { EmbroiderySectionWrapper } from '../../../../../../../components/embroidery/EmbroiderySectionWrapper/index'
import { EmbroiderySummary } from '../../../../../../../components/embroidery/EmbroiderySummary/index'
import { useEmbroidery } from '../../../../../../../containers/EmbroideryContainer/EmbroideryProvider'
import { useLoop } from '../../../../../../_providers/LoopProvider.client'
import { B2BLogoEmbroiderySection } from '../B2BLogoEmbroiderySection/index'

interface Props {
  isB2BColorSelected?: boolean
  hasBorders?: boolean
}

export const EmbroiderySection: FC<Props> = ({ isB2BColorSelected, hasBorders = true }) => {
  const {
    confirmAddEmbroidery,
    savedEmbroideryPreferences,
    requiredEmbroideryTypes,
    isProductEmbroiderable,
    hasEmbroidery,
    hasB2bLogoSelection,
  } = useEmbroidery()
  const { inLoopFlow } = useLoop()

  // Loop returns and exchanges don't offer embroidery.
  if (inLoopFlow) return null

  // Switch out embroidery section with sneak peek if the user has explicitly confirmed their embroidery selection from the modal
  const hasSelectedOptions = confirmAddEmbroidery && hasEmbroidery

  // Only display the B2B logo embroidery section if:
  // 1. A B2B color is currently selected
  // 2. The current product category enforces mandatory logo embroidery
  // 3. The current embroidery options contain the expected B2B-specific `LOGO_ONLY`/`LOGO_TEXT` options
  const displayB2BLogoEmbroiderySection =
    isB2BColorSelected && requiredEmbroideryTypes.includes('LOGO') && hasB2bLogoSelection
  return (
    <>
      {hasSelectedOptions || savedEmbroideryPreferences ? (
        <>
          <EmbroiderySummary />
          <EmbroiderySectionWrapper
            className='embroidery-settings-section-disclosure'
            hasBorder={hasBorders}
          >
            <EmbroideryDisclosure />
          </EmbroiderySectionWrapper>
        </>
      ) : isProductEmbroiderable ? (
        <>
          <EmbroideryCtaSection isB2BColorSelected={isB2BColorSelected} hasBorder={hasBorders} />
          {displayB2BLogoEmbroiderySection && <B2BLogoEmbroiderySection />}
        </>
      ) : null}
    </>
  )
}
